import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
import { Form, Spinner } from "react-bootstrap";
import { Eye, EyeSlash, ArrowRight } from "iconsax-react";

import { ROUTE_HOME_PAGE, ROUTE_FORGET_PASSWORD } from "../../../routes";

import logo from "../../../image/authentication/authentication-logo.png";
import loginType from "../../../redux/actions/login/loginType";
import { loginRequestCodeApi } from "../../../utility/api/apiList";

import { showDangerAlert } from "../../../redux/actions/alert/alertActions";
import scrollToTop from "../../../libs/scrollToTop";

import ButtonComponent from "../button";

import {
  StyledForm,
  StyledAuthenticationSection,
  StyledContainer,
  StyledAuthenticationLogoWrapper,
  StyledAuthenticationLogo,
  StyledFormGroup,
  StyledBackButton,
} from "./loginStyled";

export default function Registeration({ props }) {
  const [currentPassIsShow, setCurrentPassIsShow] = useState(false);
  const [userPassword, setUserPassword] = useState("");
  const dispatch = useDispatch();
  const loginDetail = useSelector((state) => state.loginDetail);
  const inputContainer = useRef(null);
  useEffect(() => {
    document.title = "ورود";
    scrollToTop();
    inputContainer.current.focus();
  }, []);

  const handleChangeTypeOfInputCurrentPassword = (e) => {
    e.preventDefault();
    setCurrentPassIsShow(!currentPassIsShow);
  };

  const handleUserPassword = (e) => {
    setUserPassword(e.target.value);
  };
  const handleLogin = (e) => {
    e.preventDefault();
    let prevPathPassed = "";
    if (props.location) {
      prevPathPassed = props.location.state.prevPath;
    } else {
      prevPathPassed = ROUTE_HOME_PAGE;
    }

    dispatch({
      type: "START_LOGIN",
      username: loginDetail.username,
      password: userPassword,
      prevPath: prevPathPassed,
    });
  };

  const backToAuthentication = () => {
    dispatch({
      type: loginType.CHANGE_ACTIVE_STEP,
      payload: 0,
      username: "",
    });
  };

  const handleUsernameChange = (event) => {
    loginDetail.username = event.target.value
  };
  const handleLoginBySMS = (e) => {
    e.preventDefault();
    let srtDispatch = () => {
      dispatch({ type: loginType.CHANGE_ACTIVE_STEP, payload: 2 });
    };

    let data = {
      phone: loginDetail.username,
    };
    axios
      .post(loginRequestCodeApi, data)
      .then(() => {
        srtDispatch();
      })
      .catch((error) => {
        dispatch(showDangerAlert(error.response?.data?.results));
      });
  };
  const prevPath = props.location.state.prevPath
    ? props.location.state.prevPath
    : "authentication";
  return (
    <StyledAuthenticationSection>
      <StyledContainer $maxWidth="510px">
        <StyledForm noValidate className="px-sm-5" onSubmit={handleLogin}>
          <StyledAuthenticationLogoWrapper className="mx-auto">
            <StyledAuthenticationLogo src={logo} alt="azeto-logo" />
            <h1 className="h6 text-center">ورود</h1>
          </StyledAuthenticationLogoWrapper>
          <StyledFormGroup>
            <Form.Label htmlFor="password" className="d-block text-center">
              لطفا رمز عبور شماره همراه
              <span className="text-primary"> {loginDetail.username}</span> را وارد
              کنید.
            </Form.Label>
            <div className="position-relative">

              <Form.Control
                type="text"
                name="username"
                id="username"
                value={loginDetail.username}
                onChange={handleUsernameChange}
                hidden/>
              <Form.Control
                type={currentPassIsShow ? "text" : "password"}
                ref={inputContainer}
                dir="ltr"
                onChange={handleUserPassword}
                value={userPassword}
                autoFocus
              />
              <span
                onClick={handleChangeTypeOfInputCurrentPassword}
                className="input-group-eye"
              >
                {currentPassIsShow ? (
                  <EyeSlash size="24" color="var(--blue-color-dark)" />
                ) : (
                  <Eye size="24" color="var(--blue-color-dark)" />
                )}
              </span>
            </div>

            {loginDetail.error && (
              <Form.Text className="position-absolute text-danger">
                {loginDetail.error && loginDetail.errorMessage}
              </Form.Text>
            )}
          </StyledFormGroup>

          <div className="text-center">
            {loginDetail.loading ? (
              <ButtonComponent className="px-5 mt-5 w-100" disabled>
                <Spinner
                  as="span"
                  animation="border"
                  role="status"
                  aria-hidden="true"
                ></Spinner>
              </ButtonComponent>
            ) : (
              <ButtonComponent type="submit" className="px-5 mt-5 w-100">
                تایید
              </ButtonComponent>
            )}
          </div>
          <div className="mt-5 d-flex justify-content-around justify-content-sm-between">
            <ButtonComponent
              className="px-3"
              variant="outline-primary"
              fontSize="sm"
              onClick={handleLoginBySMS}
            >
              ورود با رمز یکبار مصرف
            </ButtonComponent>
            <ButtonComponent
              isLink
              className="px-4"
              variant="outline-primary"
              fontSize="sm"
              to={{
                pathname: ROUTE_FORGET_PASSWORD,
                state: { prevPath },
              }}
            >
              فراموشی رمز عبور
            </ButtonComponent>
          </div>
        </StyledForm>

        <StyledBackButton
          onClick={() => {
            backToAuthentication();
          }}
        >
          <ArrowRight size="32" color="var(--dark-color)" variant="Outline" />
        </StyledBackButton>
      </StyledContainer>
    </StyledAuthenticationSection>
  );
}
